import React, { useState } from 'react'
import { Card, Row, Col, Button } from 'antd'
import { ClockCircleOutlined, ThunderboltOutlined, CalendarOutlined } from '@ant-design/icons'
import FlexiPriorityBooking from './FlexiPriorityBooking'

const VirtualConsultationTypeSelector = ({ SearchEngineComponent }) => {
  const [selectedType, setSelectedType] = useState(null)
  const [showFlow, setShowFlow] = useState(false)

  const consultationTypes = [
    {
      key: 'scheduled',
      title: 'Scheduled Consultation',
      description:
        'Book a specific time slot with a doctor of your choice. Perfect for routine check-ups and planned consultations.',
      icon: <CalendarOutlined style={{ fontSize: '32px', color: '#1890ff' }} />,
      color: '#1890ff',
      waitTime: 'At your chosen time'
    },
    {
      key: 'flexi',
      title: 'Flexi Consultation',
      description:
        'A doctor will contact you sometime during the day when available. Great for non-urgent consultations with flexible timing.',
      icon: <ClockCircleOutlined style={{ fontSize: '32px', color: '#52c41a' }} />,
      color: '#52c41a',
      waitTime: 'Within the day'
    },
    {
      key: 'priority',
      title: 'Priority Consultation',
      description:
        'Get immediate medical attention. A doctor will contact you within minutes. Best for urgent medical concerns.',
      icon: <ThunderboltOutlined style={{ fontSize: '32px', color: '#ff4d4f' }} />,
      color: '#ff4d4f',
      waitTime: 'Within 15 minutes'
    }
  ]

  const handleTypeSelection = (type) => {
    setSelectedType(type)
    setShowFlow(true)
  }

  const handleBack = () => {
    setSelectedType(null)
    setShowFlow(false)
  }

  // If a type is selected and we're showing the flow
  if (showFlow && selectedType) {
    if (selectedType === 'scheduled') {
      console.log('🎯 VirtualConsultationTypeSelector: Routing to SearchEngineComponent for scheduled')
      // Use the normal search engine flow for scheduled consultations
      return <SearchEngineComponent isVirtualVisit={true} onBack={handleBack} />
    } else {
      console.log('🎯 VirtualConsultationTypeSelector: Routing to FlexiPriorityBooking for', selectedType)
      // Use the simplified flexi/priority flow (with payment integration added)
      return <FlexiPriorityBooking consultationType={selectedType} onBack={handleBack} />
    }
  }

  // Show the consultation type selection
  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#262626', marginBottom: '8px' }}>
          Choose Your Virtual Consultation Type
        </h1>
        <p style={{ fontSize: '16px', color: '#8c8c8c' }}>Select the type of consultation that best fits your needs</p>
      </div>

      <Row gutter={[24, 24]} justify='center'>
        {consultationTypes.map((type) => (
          <Col xs={24} sm={24} md={8} key={type.key}>
            <Card
              hoverable
              style={{
                height: '100%',
                border: '2px solid #f0f0f0',
                borderRadius: '12px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              bodyStyle={{
                padding: '24px',
                textAlign: 'center',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
              onClick={() => handleTypeSelection(type.key)}
              onMouseEnter={(e) => {
                e.currentTarget.style.border = `2px solid ${type.color}`
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.border = '2px solid #f0f0f0'
                e.currentTarget.style.boxShadow = 'none'
              }}
            >
              <div>
                <div style={{ marginBottom: '16px' }}>{type.icon}</div>
                <h3
                  style={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: type.color,
                    marginBottom: '12px'
                  }}
                >
                  {type.title}
                </h3>
                <p
                  style={{
                    fontSize: '14px',
                    color: '#595959',
                    lineHeight: '1.5',
                    marginBottom: '16px'
                  }}
                >
                  {type.description}
                </p>
                <div
                  style={{
                    background: `${type.color}15`,
                    border: `1px solid ${type.color}30`,
                    borderRadius: '6px',
                    padding: '8px 12px',
                    marginBottom: '16px'
                  }}
                >
                  <span
                    style={{
                      fontSize: '12px',
                      fontWeight: '600',
                      color: type.color
                    }}
                  >
                    Expected Wait Time: {type.waitTime}
                  </span>
                </div>
              </div>
              <Button
                type='primary'
                size='large'
                style={{
                  backgroundColor: type.color,
                  borderColor: type.color,
                  fontWeight: '600'
                }}
                block
              >
                Select {type.title.split(' ')[0]}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default VirtualConsultationTypeSelector
